import { render, staticRenderFns } from "./ReactionsBox.vue?vue&type=template&id=718bb8f0&scoped=true&"
import script from "./ReactionsBox.vue?vue&type=script&lang=js&"
export * from "./ReactionsBox.vue?vue&type=script&lang=js&"
import style0 from "./ReactionsBox.vue?vue&type=style&index=0&id=718bb8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bb8f0",
  null
  
)

export default component.exports